import { createCustomAction } from 'typesafe-actions';

import { AuthenticationMethod } from '../../utils/Api';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_TRANSACTION_HISTORY/REQUESTED';
const BLOCKED = '$FETCH_TRANSACTION_HISTORY/BLOCKED';
const APPROVED = '$FETCH_TRANSACTION_HISTORY/APPROVED';
const SUCCEEDED = '$FETCH_TRANSACTION_HISTORY/SUCCEEDED';
const FAILED = '$FETCH_TRANSACTION_HISTORY/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      authenticationMethod?: AuthenticationMethod;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
